import { GetServerSideProps, GetServerSidePropsResult } from 'next';
import { SSRConfig } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffectOnce } from 'usehooks-ts';

import { rudderstackTrackEvent } from '@/api/rudderstack/client';
import { APP_CONFIG } from '@/app-config';
import PrivateRoute from '@/lib/private-route';
import { cleanObject } from '@/lib/utils';
import Layout from '@/modules/core/components/Layout';
import AddListingFlow from '@/modules/core/components/PostListingFlow/PostListingFlow';
import { Meta } from '@/seo/Meta';

const AddListing = () => {
  useEffectOnce(() => {
    rudderstackTrackEvent('Ad Insertion Started');
    rudderstackTrackEvent('page_view', { page_type: 'post-listing' });
  });
  return (
    <>
      <Meta
        title={`Publier un annonce sur ${APP_CONFIG.site_name}`}
        description={`Créer et publier des annonces gratuitement sur ${APP_CONFIG.site_name}`}
        canonical={`${APP_CONFIG.site_name}/post-listing`}
      />
      <AddListingFlow isPage />
    </>
  );
};

export default AddListing;

// Dynamic layout configuration
AddListing.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <PrivateRoute>
        <Layout.Wide>{page}</Layout.Wide>
      </PrivateRoute>
    </Layout>
  );
};

// Server side code and i18n
export const getServerSideProps: GetServerSideProps = async ({
  locale,
}): Promise<GetServerSidePropsResult<SSRConfig>> => ({
  props: cleanObject({
    ...(await serverSideTranslations(locale || 'en')),
  }),
});
